import { API } from "./api";

export const getAllDefaultPricings = () => API.get(`/settings`);

export const getActiveDefaultPricing = () => API.get(`/settings/active`);

export const createDefaultPricing = (pricing) => API.post(`/settings`, pricing);

export const updateDefaultPricing = (id, pricing) =>
  API.put(`/settings/${id}`, pricing);

export const deleteDefaultPricing = (pricingId) =>
  API.delete(`/settings/${pricingId}`);
